import React, { useContext, useState, useEffect } from "react";
import { Modal, Tabs } from "antd";
import { ModalContext } from "../../context/ModalContext";
import LoginForm from "../forms/LoginForm";
import ProfileForm from "../forms/ProfileForm";
import ForgotPasswordForm from "../forms/ForgotPasswordForm"; // Import the new ForgotPasswordForm

const LoginModal = () => {
    const { isLoginModalOpen, hideLoginModal, initialTab } = useContext(ModalContext);
    const [activeTab, setActiveTab] = useState(initialTab);

    useEffect(() => {
        setActiveTab(initialTab);
    }, [initialTab]);

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const tabItems = [
        {
            key: "login",
            label: "Kirjaudu",
            children: (
                <LoginForm
                    onLoginSuccess={hideLoginModal}
                    onForgotPassword={() => setActiveTab("forgot-password")}
                />
            ),
        },
        {
            key: "register",
            label: "Rekisteröidy",
            children: <ProfileForm isRegistration={true} onSaveSuccess={hideLoginModal} />,
        },
        {
            key: "forgot-password",
            label: "Unohtunut salasana",
            children: <ForgotPasswordForm />,
        },
    ];

    return (
        <Modal
            title={
                activeTab === "login"
                    ? "Kirjaudu"
                    : activeTab === "forgot-password"
                    ? "Resetoi Salasana"
                    : "Rekisteröidy"
            }
            open={isLoginModalOpen}
            onCancel={hideLoginModal}
            footer={null}
            width={700}
        >
            <Tabs activeKey={activeTab} onChange={handleTabChange} items={tabItems} />
        </Modal>
    );
};

export default LoginModal;
